import { render, staticRenderFns } from "./ProductVariantTable.vue?vue&type=template&id=e1c0b77c&"
import script from "./ProductVariantTable.vue?vue&type=script&lang=js&"
export * from "./ProductVariantTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports